import api from '../services/api'


const state = {
  deletionRequestLoader: false,
  deletionRequestStatus: false,
  deletionRequestError: null,

  createDeletionRequestLoader: false,
  onReviewTill: null,

  deleteDeletionRequestLoader: false,
}


const getters = {
  deletionRequestLoader: ({ deletionRequestLoader }) => deletionRequestLoader,
  deletionRequestStatus: ({ deletionRequestStatus }) => deletionRequestStatus,
  deletionRequestError: ({ deletionRequestError }) => deletionRequestError,

  createDeletionRequestLoader: ({ createDeletionRequestLoader }) => createDeletionRequestLoader,
  onReviewTill: ({ onReviewTill }) => onReviewTill,

  deleteDeletionRequestLoader: ({ deleteDeletionRequestLoader }) => deleteDeletionRequestLoader,
}


const mutations = {

  startDeletionRequestLoader(state) {
    state.deletionRequestLoader = true
  },

  endDeletionRequestLoader(state) {
    state.deletionRequestLoader = false
  },

  changeDeletionRequestStatus(state, val) {
    state.deletionRequestStatus = !!val
  },

  setDeletionRequestError(state, val = null) {
    state.deletionRequestError = val
  },


  startCreateDeletionRequestLoader(state) {
    state.createDeletionRequestLoader = true
  },

  endCreateDeletionRequestLoader(state) {
    state.createDeletionRequestLoader = false
  },

  changeOnReviewTill(state, val = null) {
    state.onReviewTill = val
  },


  startDeleteDeletionRequestLoader(state) {
    state.deleteDeletionRequestLoader = true
  },

  endDeleteDeletionRequestLoader(state) {
    state.deleteDeletionRequestLoader = false
  },

}


const actions = {

  async getDeletionRequest({ commit }) {
    try {
      commit('startDeletionRequestLoader')

      api.setHeaderAuth()
      api.setHeaderLang()
      const res = await api.get(`/userdeletionrequest`)

      if (res.data && res.data.data && res.data.data.on_review_till) {
        commit('changeDeletionRequestStatus', true)
        commit('changeOnReviewTill', res.data.data.on_review_till)
      } else {
        throw new Error()
      }

      commit('endDeletionRequestLoader')
    } catch (err) {
      const res = err.response.data

      if (res.meta && res.meta.availability_of_new_request) {
        commit('changeDeletionRequestStatus', false)

        switch(res.meta.availability_of_new_request) {
          case 'available':
            commit('setDeletionRequestError')
            break

          case 'unavailable_balance_below_zero':
            commit('setDeletionRequestError', 'balance_below_zero')
            break

          case 'unavailable_balance_above_zero':
            commit('setDeletionRequestError', 'balance_above_zero')
            break
          
          default:
            // ...
        }
      }

      commit('endDeletionRequestLoader')
    }
  },

  async createDeletionRequest({ commit }) {
    try {
      commit('startCreateDeletionRequestLoader')

      api.setHeaderAuth()
      api.setHeaderLang()
      const res = await api.post(`/userdeletionrequest`)

      if (res.data && res.data.data && res.data.data.on_review_till) {
        commit('changeDeletionRequestStatus', true)
        commit('changeOnReviewTill', res.data.data.on_review_till)
      } else {
        throw new Error()
      }

      commit('endCreateDeletionRequestLoader')
    } catch (err) {
      commit('endCreateDeletionRequestLoader')
    }
  },

  async deleteDeletionRequest({ commit }) {
    try {
      commit('setCreateDeletionRequestSuccess')
      commit('startDeleteDeletionRequestLoader')

      api.setHeaderAuth()
      api.setHeaderLang()
      const res  = await api.delete(`/userdeletionrequest`)

      commit('endDeleteDeletionRequestLoader')

      commit('changeDeletionRequestStatus', false)
      commit('setDeletionRequestError')
      commit('changeOnReviewTill', null)

      return res
    } catch (err) {
      commit('endDeleteDeletionRequestLoader')
    }
  },

}


export default {
  state,
  getters,
  mutations,
  actions,
}